var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"width":"500","height":"500","src":_vm.handleQrCode}})])
}
var staticRenderFns = []

export { render, staticRenderFns }